import firebase, { DocumentSnapshot } from "store/firebase";
import "firebase/firestore";

import { AnyAction, Dispatch } from "redux";
import { resultsFromDoc } from "./utils";
import { Result } from "./reducer";
import { createSubscriptionRegistry } from "store/util/subscription-registry";

export const RESULTS_MODIFIED_EVENT = "results-modified";
export const ACTION_RESULTS_LISTEN_CHANGE = "results/listen_change";

/**
 * Per-event Firestore subscription registry. Resubscribing for the same id
 * replaces the previous listener; subscribing for a different id leaves the
 * existing one alone. Replaces the singleton `let _unsubscribe`.
 */
const subscriptions = createSubscriptionRegistry();

export function subscribe(id: string) {
  subscriptions.subscribe(id, () => {
    const itemRef = firebase.firestore().collection("results").doc(id);
    return itemRef.onSnapshot((snapshot: DocumentSnapshot) => {
      const item = resultsFromDoc(snapshot);
      const windowEvent = new CustomEvent(RESULTS_MODIFIED_EVENT, {
        detail: item,
      });
      window.dispatchEvent(windowEvent);
    }, console.log);
  });
}

export function unsubscribe(id?: string) {
  if (id) {
    subscriptions.unsubscribe(id);
  } else {
    subscriptions.unsubscribeAll();
  }
}

export default function listenChange(event: Result) {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_RESULTS_LISTEN_CHANGE, payload: event });
  };
}
